import { React, useEffect, useState } from 'react';
import classes from './AppHdSingleTitle.module.css'

const AppHdSingleTitle = (props) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 

    useEffect(() => {       
            const handleResize = () => {
                setIsMobile(window.innerWidth < 768);
              };
          
              window.addEventListener('resize', handleResize);
          
              return () => {
                window.removeEventListener('resize', handleResize);
              };
              // eslint-disable-next-line react-hooks/exhaustive-deps
          },[]);

    return(
        <>
            {isMobile ? (
                <h1 className={classes.navtitle}>{props.children}</h1>

            ) : (
                <div style={{ width: '100%' }}>
                    <h1 className={classes.navtitle}>{props.children}</h1>
                </div>
            )}
        </>
    )
}

export default AppHdSingleTitle;